<div class="placeholder-glow" [class.p-2]="compact" [class.p-3]="!compact" role="status">
  <span class="visually-hidden">{{ 'chat.states.loading' | translate }}</span>

  @for (row of rowList; track row) {
    <div class="d-flex align-items-center gap-2 py-2" aria-hidden="true">
      <span class="placeholder rounded-circle chat-skeleton__avatar"></span>
      <span class="flex-grow-1">
        <span class="placeholder d-block col-7 mb-1"></span>
        <span class="placeholder d-block chat-skeleton__line--sm" [class.col-10]="row % 2 === 0" [class.col-8]="row % 2 === 1"></span>
      </span>
    </div>
  }
</div>
